export enum ProductStatusEnum{
	draft = 'DRAFT',//blue
	pending = 'PENDING',//yellow
	live = 'LIVE',//green
	archived = 'ARCHIVED'//gray
}



// draft = 'DRAFT',//blue
// awaitingApproval = 'AWAITING APPROVAL',//yellow
// approved = 'APPROVED',//green
// archived = 'ARCHIVED'//gray